import styled from "@emotion/styled";

import { fontMerriweather, theme, ZIndexLayer } from "shared/lib/styles";

import { ArticleDateAndLabelContainer } from "scmp-app/components/article/article-author-block/styles";
import { StyledDiv } from "scmp-app/components/article/article-date/default-article-date/styles";
import { NewsletterArticleIssues } from "scmp-app/components/article/article-render/newsletter-article/issues";

import { NewsletterArticleBreadcrumb } from "./breadcrumb";

export const StyledNewsletterArticleBreadcrumb = styled(NewsletterArticleBreadcrumb)`
  ${theme.breakpoints.down("tablet")} {
    margin-block-end: 16px;
  }
`;

export const StyledNewsletterArticleIssues = styled(NewsletterArticleIssues)`
  z-index: ${ZIndexLayer.NewsletterArticleIssues};
`;

export const AuthorBlock = styled.div`
  max-inline-size: 336px;
  margin-inline: auto;
  ${ArticleDateAndLabelContainer} {
    flex-flow: column;
  }
  ${StyledDiv} {
    ${theme.breakpoints.up("tablet")} {
      min-block-size: 0;
    }
  }
`;

export const Container = styled.div`
  margin-block: 0;
  margin-inline: auto;
`;

export const Headline = styled.div`
  margin-block-end: 60px;

  color: #000000;
  font-weight: 300;
  font-size: 30px;
  font-family: ${fontMerriweather};
  line-height: 42px;
  text-align: center;

  ${theme.breakpoints.up("tablet")} {
    font-size: 48px;
    line-height: 64px;
  }
`;

export const Navigation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  inline-size: 100%;
  margin-block-end: 16px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    justify-content: space-between;

    margin-block-end: 28px;
  }
`;
